"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCountOfPages = void 0;
var _constants = require("./constants");
/**
 * Utility to compute amount of articles pages. Decides based on `countOfArticles` and `pageSize`.
 * @returns Count of pages
 */ const getCountOfPages = (param)=>{
    let { countOfArticles = 0, pageSize = _constants.DEFAULT_PAGE_SIZE } = param;
    return pageSize > 0 ? Math.ceil(countOfArticles / pageSize) : 0;
};
exports.getCountOfPages = getCountOfPages;
